module.exports = __webpack_public_path__ + "static/media/notiPhone.d763e000.png";